import { Tooltip } from '@mui/material'
import React from 'react'

/** Texto de celda recortado con "…" y el valor completo en el tooltip. */
export const ClipText = ({ text, strong = false, maxWidth = 240 }: { text: string, strong?: boolean, maxWidth?: number }) => (text ? (
    <Tooltip title={text} placement="top-start">
        <span className={`block truncate ${strong ? 'font-bold text-k-ink' : 'text-k-ink-2'}`} style={{ maxWidth }}>{text}</span>
    </Tooltip>
) : <span className="text-k-muted">—</span>)

export const ReportKpi = ({ label, value, hint, tone }: { label: string, value: string, hint?: string, tone?: 'danger' }) => (
    <div className={`flex flex-col gap-1 rounded-2xl border px-4 py-3.5 ${tone === 'danger' ? 'border-k-danger-soft bg-k-danger-soft/40' : 'border-k-line bg-k-surface'}`}>
        <span className="text-xs font-bold uppercase tracking-[0.05em] text-k-muted">{label}</span>
        <span className={`text-[22px] font-extrabold tabular-nums tracking-[-0.02em] ${tone === 'danger' ? 'text-k-danger-ink' : 'text-k-ink'}`}>{value}</span>
        {hint && <span className="text-xs text-k-muted">{hint}</span>}
    </div>
)

export interface ChipTabsProps<T extends string> {
    label: string
    tabs: Array<{ id: T; label: string }>
    value: T
    onChange: (value: T) => void
}

export const ChipTabs = <T extends string>({ label, tabs, value, onChange }: ChipTabsProps<T>) => (
    <div role="tablist" aria-label={label} className="flex flex-wrap gap-2">
        {tabs.map((tab) => {
            const on = value === tab.id
            return (
                <button
                    key={tab.id}
                    type="button"
                    role="tab"
                    aria-selected={on}
                    onClick={() => onChange(tab.id)}
                    className={`inline-flex min-h-[36px] items-center rounded-full border px-3.5 text-[13px] ${on
                        ? 'border-k-ink bg-k-ink font-bold text-k-surface'
                        : 'border-k-line-strong bg-k-surface font-semibold text-k-ink-2 hover:bg-k-hover'}`}
                >
                    {tab.label}
                </button>
            )
        })}
    </div>
)
